import {Page} from 'utils/page-utils';
import {fetchCleanedData} from 'router/router-utils';
import EventEligibilityAPI from 'api/checkout/eligibility';
import AuthenticationUtils from 'utils/authentication';
import {getParkingSpotIdFromUrl} from 'api/checkout/utils';

const getInitialState = async ({state: initialState, route, cookies}) => {
    const apiConfig = AuthenticationUtils.getAPIConfig(cookies);
    const parkingSpotId = getParkingSpotIdFromUrl(route.location.pathname);

    await EventEligibilityAPI.checkEligibility(parkingSpotId, apiConfig);

    // TODO: `fetchCleanedData` is a relic of the previous data-fetching system and does more than Checkout needs
    const state = await fetchCleanedData({
        state: initialState,
        route,
    });

    state.searchRequest.pageType = Page.CHECKOUT;

    return state;
};

export default getInitialState;
